import { Auth } from 'aws-amplify';
import appConfig from '../config/app-config';
import type { DocumentAssignor } from '../components/pages/billing/collection/collectionAgreementSuggestion';

const { address: API_URL, key: API_KEY } = appConfig.apis.convertXmlApiEnv;

export const listDocumentAssignors = async (documentIds: string[]): Promise<DocumentAssignor[]> => {
    if (documentIds.length === 0) return [];
    const session = await Auth.currentSession();
    const response = await fetch(`${API_URL}/documents/assignors`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': API_KEY || '',
            Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
        },
        body: JSON.stringify({ documentIds }),
    });
    if (!response.ok) throw new Error(`Erro ao buscar os cedentes das notas: status ${response.status}`);
    const body = await response.json();
    return body.data || [];
};
